import { render, staticRenderFns } from "./PsinEdit.vue?vue&type=template&id=a6753cf4&scoped=true&"
import script from "./PsinEdit.vue?vue&type=script&lang=js&"
export * from "./PsinEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6753cf4",
  null
  
)

export default component.exports